/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GraduatoriaBilancioDTO } from './graduatoria-bilancio-dto';
import { TipoGraduatoria } from './tipo-graduatoria';
import { LimiteAssegnazione } from './limite-assegnazione';
import { StatoGraduatoria } from './stato-graduatoria';
import { DirezioneOrdinamento } from './direzione-ordinamento';
import { OrdinamentoPariPunteggio } from './ordinamento-pari-punteggio';
import { GraduatoriaEligibilitaNodoDTO } from './graduatoria-eligibilita-nodo-dto';
import { RigaConfineModalita } from './riga-confine-modalita';


export interface GraduatoriaSnapshotDTO { 
    id?: string;
    tipo_pratica_id?: string;
    nome?: string;
    stato?: StatoGraduatoria;
    calcolata_il?: string;
    creata_da?: string;
    confermata_il?: string;
    stale?: boolean;
    stale_motivo?: GraduatoriaSnapshotDTOStaleMotivoEnum;
    override_budget_totale?: number;
    override_limite_assegnazione?: LimiteAssegnazione;
    override_numero_massimo_beneficiari?: number;
    snapshot_tipo_graduatoria?: TipoGraduatoria;
    snapshot_direzione_ordinamento?: DirezioneOrdinamento;
    snapshot_ordinamento_pari_punteggio?: OrdinamentoPariPunteggio;
    snapshot_limite_assegnazione?: LimiteAssegnazione;
    snapshot_budget_totale?: number;
    snapshot_numero_massimo_beneficiari?: number;
    snapshot_criteri_spareggio?: Array<{ [key: string]: any; }>;
    snapshot_riga_confine_modalita?: RigaConfineModalita;
    graduatoria_padre_id?: string;
    graduatoria_padre_nome?: string;
    snapshot_residuo_budget?: number;
    snapshot_residuo_posti?: number;
    bilancio?: GraduatoriaBilancioDTO;
    eligibilita?: Array<GraduatoriaEligibilitaNodoDTO>;
    version?: number;
}
export enum GraduatoriaSnapshotDTOStaleMotivoEnum {
    PUNTEGGI = 'PUNTEGGI',
    PADRE = 'PADRE',
    PADRE_NON_CONFERMATO = 'PADRE_NON_CONFERMATO'
};



